import { bylineTileCountsRecorder } from '@confluence/ssr-utilities/entry-points/ObjectRecorder.ts';

/**
 * Hands the tile count the server painted to the browser, so hydration reproduces it instead of
 * recounting. A recount can differ: the caches sent with the page can hold sample answers that
 * arrived after the server rendered the byline. The server records into a per-request recorder,
 * which the SSR app ships as `window.__SSR_BYLINE_TILES__` with the page's globals; the browser
 * has those before it hydrates. Not a window property on the server: live and edit pages stream
 * with a mocked window, so a write there never reaches the globals. CCINT-9543
 */

/** Server render only. The first count recorded for a page is the one it painted first. */
export const recordServerTileCount = (contentId: string, tileCount: number): void => {
	const counts = bylineTileCountsRecorder.get() ?? {};
	if (!(contentId in counts)) {
		bylineTileCountsRecorder.set({ ...counts, [contentId]: tileCount });
	}
};

/** The count the server painted for this page; zero when it recorded none, as it then painted none. */
export const readServerTileCount = (contentId: string): number => {
	const count = window.__SSR_BYLINE_TILES__?.[contentId];
	return typeof count === 'number' && Number.isInteger(count) && count > 0 ? count : 0;
};
